import L from "../../@babel/runtime/helpers/esm/extends2.mjs";
import C from "../../@babel/runtime/helpers/esm/objectWithoutProperties2.mjs";
import c from "../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import M from "../../@babel/runtime/helpers/esm/classCallCheck2.mjs";
import K from "../../@babel/runtime/helpers/esm/createClass2.mjs";
import _ from "../../@babel/runtime/helpers/esm/assertThisInitialized2.mjs";
import R from "../../@babel/runtime/helpers/esm/inherits2.mjs";
import x from "../../@babel/runtime/helpers/esm/createSuper2.mjs";
import y from "../../@babel/runtime/helpers/esm/defineProperty2.mjs";
import * as d from "react";
import O from "./CSSMotion.mjs";
import { STATUS_REMOVED as E, parseKeys as D, diffKeys as V, STATUS_REMOVE as N, STATUS_ADD as U, STATUS_KEEP as j } from "./util/diff.mjs";
import { supportTransition as F } from "./util/motion.mjs";
var I = ["component", "children", "onVisibleChanged", "onAllRemoved"], $ = ["status"], w = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function z(W) {
  var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : O, S = /* @__PURE__ */ function(P) {
    R(u, P);
    var h = x(u);
    function u() {
      var r;
      M(this, u);
      for (var a = arguments.length, s = new Array(a), t = 0; t < a; t++)
        s[t] = arguments[t];
      return r = h.call.apply(h, [this].concat(s)), y(_(r), "state", {
        keyEntities: []
      }), y(_(r), "removeKey", function(m) {
        r.setState(function(i) {
          var n = i.keyEntities.map(function(e) {
            return e.key !== m ? e : c(c({}, e), {}, {
              status: E
            });
          });
          return {
            keyEntities: n
          };
        }, function() {
          var i = r.state.keyEntities, n = i.filter(function(e) {
            var p = e.status;
            return p !== E;
          }).length;
          n === 0 && r.props.onAllRemoved && r.props.onAllRemoved();
        });
      }), r;
    }
    return K(u, [{
      key: "render",
      value: function() {
        var a = this, s = this.state.keyEntities, t = this.props, m = t.component, i = t.children, n = t.onVisibleChanged;
        t.onAllRemoved;
        var e = C(t, I), p = m || d.Fragment, v = {};
        return w.forEach(function(o) {
          v[o] = e[o], delete e[o];
        }), delete e.keys, /* @__PURE__ */ d.createElement(p, e, s.map(function(o, T) {
          var k = o.status, l = C(o, $), b = k === U || k === j;
          return /* @__PURE__ */ d.createElement(g, L({}, v, {
            key: l.key,
            visible: b,
            eventProps: l,
            onVisibleChanged: function(f) {
              n == null || n(f, {
                key: l.key
              }), f || a.removeKey(l.key);
            }
          }), function(A, f) {
            return i(c(c({}, A), {}, {
              index: T
            }), f);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(a, s) {
        var t = a.keys, m = s.keyEntities, i = D(t), n = V(m, i);
        return {
          keyEntities: n.filter(function(e) {
            var p = m.find(function(v) {
              var o = v.key;
              return e.key === o;
            });
            return !(p && p.status === E && e.status === N);
          })
        };
      }
    }]), u;
  }(d.Component);
  return y(S, "defaultProps", {
    component: "div"
  }), S;
}
const ne = z(F);
export {
  ne as default,
  z as genCSSMotionList
};
//# sourceMappingURL=CSSMotionList.mjs.map
